module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-dropDown-menu",
    class: {
      'disabled': _vm.disabled
    }
  }, [_c('svg', {
    staticClass: "mu-dropDown-menu-icon",
    class: _vm.iconClass,
    attrs: {
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M7 10l5 5 5-5z"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "mu-dropDown-menu-text",
    class: _vm.labelClass,
    on: {
      "click": _vm.handleOpen
    }
  }, [_c('div', {
    staticClass: "mu-dropDown-menu-text-overflow"
  }, [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('div', {
    staticClass: "mu-dropDown-menu-line",
    class: _vm.underlineClass
  }), _vm._v(" "), (!_vm.disabled && _vm.$slots && _vm.$slots.default && _vm.$slots.default.length > 0) ? _c('popover', {
    attrs: {
      "scroller": _vm.scroller,
      "open": _vm.openMenu,
      "trigger": _vm.trigger,
      "anchorOrigin": _vm.anchorOrigin
    },
    on: {
      "close": _vm.handleClose
    }
  }, [_c('mu-menu', {
    class: _vm.menuClass,
    style: ({
      width: _vm.menuWidth + 'px'
    }),
    attrs: {
      "listClass": _vm.menuListClass,
      "value": _vm.value,
      "multiple": _vm.multiple,
      "autoWidth": _vm.autoWidth,
      "popover": _vm.openMenu,
      "desktop": "",
      "maxHeight": _vm.maxHeight
    },
    on: {
      "change": _vm.change,
      "itemClick": _vm.itemClick
    }
  }, [_vm._t("default")], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c19449a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/muse-ui/src/dropDownMenu/dropDownMenu.vue
// module id = 3592
// module chunks = 1